@if (title && title.length > 0) {
    <div [ngClass]="classNames" role="tooltip" #tooltip>
        <div class="tooltip-arrow"></div>
        <div class="tooltip-inner">{{ title }}</div>
    </div>
}
